function UserList(data) {
    this.list = this.createTableData(data);
}

UserList.prototype = Object.assign(UserList.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.userDetailsList &&
            tableData.userDetailsList.map(row => this.createRow(row))
        );
    },
    createRow(row) {
        const { userDetails } = row;
        const { userId, name } = userDetails;
        return {
            name,
            value: userId,
        };
    },
});

export default UserList;
